export default {
    init() {
        // JavaScript to be fired on the about us page


        // POST GRID
        (function () {
            const $container = $('.posts-grid');
            const $entries = $container.find('.entry-content');

            const getEntryHeight = () => {
                $entries.each(function () {
                    const $this = $(this);
                    $this.css('height', 'auto');
                    $this.css('height', $this.outerHeight());
                });
            }

            $(window).on('load resize', function () {
                getEntryHeight();
            });
        })();

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/category.js